import { useState } from 'react';

import { useAdRewardOn, usePluginMessages } from '../../../composition/plugin-runtime';
import { useLlmChat, type LlmChatParams } from '../composition/use-llm-chat';
import { chatErrorMessageKey } from '../domain/chat';
import { useSendOnEnter } from './send-on-enter';

/** 견본 화면 — MVP 가 이 파일을 자기 대화 화면으로 바꾼다. 훅(useLlmChat)과 문구 키는 그대로 쓴다 */
export function ChatWidget(props: LlmChatParams) {
  const t = usePluginMessages('llm');
  const { signedIn, chat, balance, send, cancel } = useLlmChat(props);
  const adRewardOn = useAdRewardOn();
  const [prompt, setPrompt] = useState('');
  const streaming = chat.status === 'streaming';
  const canSend = !streaming && prompt.trim() !== '';
  const submit = () => {
    if (!canSend) return false;
    void send([{ role: 'user', content: prompt.trim() }]);
    return true;
  };
  const enter = useSendOnEnter(submit, streaming);
  // 로그인하지 않으면 이용권이 없다 — 자리 자체를 그리지 않는다
  if (!signedIn) return null;
  return (
    <section aria-label={t('label')}>
      <p role="status">
        {t('balance')}: {balance === null ? '-' : balance}
      </p>
      <textarea
        ref={enter.ref}
        aria-label={t('prompt')}
        value={prompt}
        onChange={event => setPrompt(event.target.value)}
        onKeyDown={enter.onKeyDown}
        disabled={streaming}
      />
      <button type="button" disabled={!canSend} onClick={submit}>
        {t('send')}
      </button>
      {streaming && (
        <button type="button" onClick={cancel}>
          {t('stop')}
        </button>
      )}
      {chat.text !== '' && <p aria-live="polite">{chat.text}</p>}
      {chat.error && <p role="alert">{t(chatErrorMessageKey(chat.error, adRewardOn))}</p>}
    </section>
  );
}

/** 슬롯은 props 없는 컴포넌트를 받는다 — 플러그인 설정을 묶어 넘긴다 */
export function chatWidget(props: LlmChatParams) {
  return function BoundChatWidget() {
    return <ChatWidget {...props} />;
  };
}
